module.exports = __webpack_public_path__ + "img/mt5Bg.fc5f0e6d.png";